import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { checkRole } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-claim-modal',
  templateUrl: './claim-modal.component.html',
  styleUrls: ['./claim-modal.component.css']
})
export class ClaimModalComponent implements OnInit {
  @Input() claimTrip;
  @Output() close = new EventEmitter<any>();
  claimForm!: FormGroup;
  claimTotal: number = 0;
  submitted = false;
  isFromBilling = true;
  user;

  constructor(
    private fb: FormBuilder,
    private dispatchCenterService: DispatchCenterService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.claimForm = this.fb.group({
      claims: this.fb.array([])
    });

    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;

          if (this.claimTrip.claims && this.claimTrip.claims.length > 0) {
            this.addClaimItem(this.claimTrip.claims);
          }
        }
      });
  }

  onCloseModal() {
    this.close.emit();
  }


  removeClaimItem(index: any) {
    const items = this.claimForm.get('claims') as FormArray;
    items.removeAt(index);
    this.calculateTotalClaim(items);
  }

  addClaimItem(preClaims?: any) {
    const items = this.claimForm.get('claims') as FormArray;
    if (preClaims && preClaims.length > 0) {
      preClaims.forEach((element: any) => {
        items.push(
          this.fb.group({
            claim: [parseFloat(element.claim), [Validators.required, this.minValueValidator(1)]],
            fileName: [element.fileName],
            createdAt: [moment(element.createdAt).tz(this.user.timeZone)],
            preCreatedAt: [moment(element.createdAt).tz(this.user.timeZone).format('MM/DD/YYYY')],
          })
        );
      });
      this.calculateTotalClaim(items)
      return;
    }
    items.push(
      this.fb.group({
        claim: [0, [Validators.required, this.minValueValidator(1)]],
        fileName: [''],
        createdAt: [moment().tz(this.user.timeZone)],
        preCreatedAt: [moment().tz(this.user.timeZone).format('MM/DD/YYYY')],
      })
    );
    this.calculateTotalClaim(items)
  }

  calculateTotalClaim(formGroup: any) {
    let total = 0;
    formGroup.value.forEach((element: any) => {
      total += element.claim;
    });
    this.claimTotal = total;
  }


  onSubmit() {
    this.submitted = true;
    if (this.claimForm.invalid) {
      return;
    }
    const payload = this.claimForm.value;
    this.dispatchCenterService
      .saveTripAdjustment(this.claimTrip._id, payload, this.isFromBilling)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          sweetAlert('Success', 'Updated Successfully!', 'success', 'OK');
          this.close.emit(data);
        } else {
          sweetAlert('Error', "Something went wrong!", 'warning', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
    console.log("claimForm", this.claimForm.value);
  }

  get claims(): FormArray {
    return this.claimForm.get('claims') as FormArray;
  }

  onClaimChange() {
    const items = this.claimForm.get('claims') as FormArray;
    this.calculateTotalClaim(items)
  }


  unclaimedAmount() {
    return (parseFloat(this.claimTrip.preSpecialRate) - this.claimTotal).toFixed(2);
  }

  normalTotalFare() {
    return parseFloat(this.claimTrip.preSpecialRate).toFixed(2)
  }

  ngOnDestroy() {
  }

  minValueValidator(min: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value < min ? { minValue: { requiredMin: min, actual: control.value } } : null;
    };
  }
}
